import { createTheme } from '@mui/material/styles';

// Shared Material-UI theme to avoid multiple theme instantiations
// Uses minimal configuration to prevent circular dependency issues
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#3b82f6', // primary-500 from Tailwind
    },
  },
});
